import React, { useState, useEffect, useMemo } from "react";
import { Typography, Grid } from "@mui/material";
import CustomTable from "components/TableExplanded/Table";
import CustomPagination from "components/TableExplanded/Pagination";
import useProductData from "pages/Pawn/Products/ReadyItems/data/data";
import useColumns from "pages/Pawn/Products/ReadyItems/columns/mainColumns";
import useColumnsTwo from "pages/Pawn/Products/ReadyItems/columns/subColumns";
import Modal from "components/Modal/Pawn/ReadyItems/ModalCreateReadyItems";
// import ModalMarketplace from "components/Modal/Pawn/Create/ModalReadyItemsMarketplace";
import ViewModal from "components/Modal/Pawn/View/ViewModalReadyItems";
import SearchBar from "components/TableExplanded/SearchBar";
import dayjs from "dayjs";
import api from "_api";
import ModalUploadToMarketplace from "components/Modal/MarketPlace/ModalUploadToMarketplace";
import { GradientButtonOutline } from "components/GradientButton";
import SaveIcon from "@mui/icons-material/Save";

const ReadyItems = ({ className }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalMarketOpen, setModalMarketOpen] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [selectedProduct, setProduct] = useState(null);
  const [viewProduct, setViewProduct] = useState(null);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState([null, null]);
  const [fetchData, setFetchData] = useState();
  const [searchQuery, setSearchQuery] = useState(""); // Store the search query
  const [dataLength, setDataLength] = useState(0);

  const fetchProductData = async ({
    searchCode = "",
    searchPrice = "",
    searchProduct = "",
    searchDate = "",
    page = 1,
    limit = 10,
  }) => {
    console.log(searchCode);
    try {
      const { data, isStatus, total } = await api.product.getSellOrdersV2(
        searchCode,
        searchPrice,
        searchProduct,
        searchDate,
        page,
        limit
      );
      if (isStatus) setFetchData(data);
      setDataLength(total);
    } catch (error) {
      console.error("Error fetching product data:", error);
    }
  };

  useEffect(() => {
    fetchProductData({
      search: searchQuery,
      page: page + 1,
      limit: rowsPerPage,
    });
  }, [searchQuery, page, rowsPerPage]);

  // console.log("fetchData", fetchData);

  const handleModalOpen = () => {
    setModalOpen(!isModalOpen);
    if (selectedProduct && isModalOpen) setProduct(null);
  };

  const handleModalOpenMarketplace = () => {
    setModalMarketOpen(!isModalMarketOpen);
    if (selectedProduct && isModalMarketOpen) setProduct(null);
  };

  const handleViewOpen = () => {
    setViewModalOpen(!isViewModalOpen);
    if (viewProduct && isViewModalOpen) setViewProduct(null);
  };

  const data = useProductData(fetchData);
  const columns = useColumns(
    setViewProduct,
    setProduct,
    handleViewOpen,
    handleModalOpen,
    handleModalOpenMarketplace
  );
  const columnsInside = useColumnsTwo();
  const visibleColumns = columns.filter((col) => col.showInFilter);

  // useEffect(() => {
  //   setFilteredRows(data);
  // }, [data]);

  // const filteredData = useMemo(() => {
  //   if (!searchQuery) return data; // If no search query, return all data

  //   return data.filter((row) => {
  //     return visibleColumns.some((column) => {
  //       const cellValue = row[column.accessor]?.toString()?.toLowerCase();
  //       return cellValue && cellValue.includes(searchQuery.toLowerCase());
  //     });
  //   });
  // }, [data, searchQuery, visibleColumns]);

  const handleSearchChange = (event) => {
    if (
      event &&
      event.target &&
      event.target.value !== undefined &&
      event.target.value !== null
    ) {
      const query = event.target.value.toLowerCase();
      setSearchTerm(query);
      setSearchQuery(query); // Update searchQuery with the search term
    } else {
      console.error("Event target or value is undefined");
    }
    setPage(0); // Reset page when search changes
  };
  const handleDateRangeChange = (dates) => {
    setSelectedDateRange(dates);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClear = () => {
    setSearchTerm("");
    setSelectedDateRange([null, null]);
    setFilteredRows(data);
    setPage(0);
    fetchProductData({ search: "", page: 1, limit: rowsPerPage });
  };

  const handleExportExcel = async () => {
    console.log("Export Excel");
    await api.product
      .exportExcelSellProduct()
      .then((res) => {
        const contentDisposition = res.headers["content-disposition"];
        let filename = "download.xlsx"; // Default กรณีไม่มีชื่อไฟล์จาก API

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+?)"?$/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.error("Error exporting excel:", error);
      });
  };

  return (
    <div className={className}>
      <Grid container spacing={2} style={{ marginBottom: "16px" }}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography component="div" style={{ fontSize: "32px" }}>
            สินค้าพร้อมขาย
          </Typography>
          <GradientButtonOutline
            onClick={handleExportExcel}
            sx={{
              px: 3,
              display: "flex",
              alignItems: "center",
              height: "48px",
            }}
          >
            <Typography style={{ marginRight: "8px" }}>ส่งออก Excel</Typography>
            <SaveIcon fontSize="medium" />
          </GradientButtonOutline>
        </Grid>
      </Grid>

      <SearchBar
        columns={columns}
        searchTerm={setSearchTerm}
        visibleColumns={visibleColumns} // กรองคอลัมน์ที่ต้องการแสดง
        handleSearchChange={handleSearchChange}
        // handleSearchClick={handleSearchClick}
        handleClear={handleClear}
        handleDateRangeChange={handleDateRangeChange}
        fetchData={fetchData}
        handleSearchClick={(filters) => {
          console.log("filter check>>>>", filters);
          const data = {
            searchCode: filters.product_code || "",
            searchProduct: filters.product_name || "",
            searchPrice: filters.price || "",
            searchDate: filters.created_date || "",
            page: 1,
            limit: rowsPerPage,
          };
          fetchProductData(data);
        }}
        QRCode={false}
      />

      <CustomTable
        columns={columns}
        columnsInside={columnsInside}
        searchTerm={searchTerm}
        data={data}
        page={page}
        rowsPerPage={rowsPerPage}
        setDataLength={setDataLength}
      />

      <CustomPagination
        count={dataLength}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />

      <Modal
        open={isModalOpen}
        onClose={handleModalOpen}
        selectedProduct={selectedProduct}
        // fetchProductData={fetchProductData}
        fetchProductData={() =>
          fetchProductData({
            search: searchQuery,
            page: page + 1,
            limit: rowsPerPage,
          })
        }
      />

      {/* <ModalMarketplace
        open={isModalMarketOpen}
        onClose={handleModalOpenMarketplace}
        selectedProduct={selectedProduct}
        fetchProductData={fetchProductData}
      /> */}
      <ModalUploadToMarketplace
        open={isModalMarketOpen}
        onClose={handleModalOpenMarketplace}
        selectedProduct={selectedProduct}
        fetchData={() =>
          fetchProductData({
            searchCode: "",
            searchPrice: "",
            searchProduct: "",
            searchDate: "",
            page: page + 1,
            limit: rowsPerPage,
          })
        }
      />

      <ViewModal
        open={isViewModalOpen}
        onClose={handleViewOpen}
        selectedProduct={viewProduct}
        // fetchProductData={fetchProductData}
        fetchProductData={() =>
          fetchProductData({
            search: searchQuery,
            page: page + 1,
            limit: rowsPerPage,
          })
        }
      />
    </div>
  );
};

export default ReadyItems;
